import { useState } from 'react';
import { Button } from '@/components/atoms/NewPcButton';
import { Dialog, DialogTrigger } from '@/components/atoms/Dialog';
import { MonitoringGoodsDetail } from '@/types/api';
import RegisteredMonitoringEdit from './RegisteredMonitoringEdit';
import { useMembershipMonitoringPreviewTutorial } from '@/components/membership/MembershipMonitoringPreviewTutorial';

const EditKeyword = ({
  goods,
  isMockGoods,
}: {
  goods: MonitoringGoodsDetail;
  isMockGoods: boolean;
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { openTutorial } = useMembershipMonitoringPreviewTutorial();

  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <div className="flex flex-col items-end gap-2">
        <DialogTrigger asChild>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              if (openTutorial('editKeywords')) {
                e.preventDefault();
              }
            }}
            variant="secondary"
            className="h-fit px-[10px] py-[6px] Body5M14"
          >
            키워드 관리
          </Button>
        </DialogTrigger>
        <RegisteredMonitoringEdit
          goods={goods}
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          isMockGoods={isMockGoods}
        />
      </div>
    </Dialog>
  );
};

export default EditKeyword;
